"use client"

import { ComponentConfig } from "@measured/puck"
import { CommonStylesProps } from "../../lib/commonCSSProps"
import { SlideItem } from "../../lib/SlideItem"
import { RenderConfig } from "./RenderConfig"

export interface CardServiceProps extends CommonStylesProps {
  items: Array<{ title: string; image: string; link: string }>
}

export const CardService: ComponentConfig<CardServiceProps> = {
  label: "Card Service",
  // @ts-ignore
  fields: {
    items: {
      type: "array",
      label: "Items",
      min: 1,
      arrayFields: {
        title: {
          type: "text",
          label: "Tiêu đề",
        },
        image: {
          label: "Image",
          type: "custom",
          render: props => <SlideItem {...props} />,
        },
        link: {
          label: "Link",
          type: "text",
        },
      },
    },
  },
  defaultProps: {
    items: [{ title: "Gia công phần mềm", image: "", link: "/" }],
    className: "",
  },
  ...RenderConfig,
}
